import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DebounceDirective} from './debounce.directive';
import {AutosizeDirective} from './autosize.directive';
import {AutofocusDirective} from './autofocus.directive';
import {LoadingDirective} from './loading.directive';
import { LoadingModule } from '../loading/loading.module';
import { TooltipDirective } from './tooltip-directive/tooltip.directive';
import { NgbdSortableHeaderDirective } from './sortable-header.directive';

@NgModule({
  imports: [
    CommonModule,
    LoadingModule
  ],
  declarations: [DebounceDirective, AutosizeDirective, AutofocusDirective, LoadingDirective, TooltipDirective, NgbdSortableHeaderDirective],
  exports: [DebounceDirective, AutosizeDirective, AutofocusDirective, LoadingDirective, TooltipDirective, NgbdSortableHeaderDirective]
})
export class QmDirectivesModule {
}
